(function($){
  var allowAction;

  $.rails.prompt = function(message, defaultValue) {
    return window.prompt(message, defaultValue);
  };

  $.rails.handlePrompt = function(element) {
    var callback, config, defaultValue, message, param, params, query_symbol, value;
    config = element.data('prompt');
    message = config.message || config;
    defaultValue = config["default"];
    param = config.param || 'value';
    if (!message) {
      return true;
    }
    if ($.rails.fire(element, 'prompt')) {
      value = $.rails.prompt(message, defaultValue);
      callback = $.rails.fire(element, 'prompt:complete', [value]);
    }
    if (element.data("remote") == null) {
      query_symbol = /[?].+[=]/.test(element.attr("href")) ? "&" : "?";
      element.attr("href", element.attr("href") + query_symbol + encodeURIComponent(param) + "=" + encodeURIComponent(value));
    }
    params = element.data('params') || {};
    params[param] = value;
    element.data('params', params);
    return value && callback;
  };

  allowAction = $.rails.allowAction;

  $.rails.allowAction = function(element) {
    if (element.data('prompt')) {
      return $.rails.handlePrompt(element);
    } else {
      return allowAction(element);
    }
  };
})(jQuery);
